import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux";
import { Button, Dropdown, Typography, Card, Row, Spin, Tooltip} from "antd";
import { getDropdownKey, getMetricDropdownLabel, isAssignedMetric, get_metric_info_from_identifier } from "../../Utils/chart_utils";
import { trainingAPI } from "../../api/TrainingAPI";
import CompactStatisticNumber from "./CompactStaticNumber";
import "../../Styles/styles-Profile.css";


const { Link } = Typography;

export const CompactStatTile = ({
  dropdowns,
  metric_identifier_with_stat,
  onChange = () => {},
  metricType,
  stat,
  option,
  endDate,
  startDate,
  playerId,
  type,
  positionFilter
}) => {
  const {
    filter: { position, player_group },
    all_metric_types,
    metrics
  } = useSelector(({ team }) => team);
  const [statData, setStatData] = useState({ left: {}, right: {} });
  const [loading, setLoading] = useState(false);
  const [dropdownsLocal, setDropDownsLocal] = useState(dropdowns)

  const {metric_id, metric_stat} = get_metric_info_from_identifier(metric_identifier_with_stat);
  const metric_type = metric_id?.split('-')?.[0];

  const metric = useMemo(() => {
    return Object.values(all_metric_types)
      .flat()
      .find((metric) => getDropdownKey(metric, "metricId") === metric_id);
  }, [all_metric_types, metric_id]);

  useEffect(() => {
    if (dropdowns.length > 0) {
      if (dropdowns[0]?.children) {
        setDropDownsLocal(dropdowns.map((dropdownLocal) => {
          if (dropdownLocal.key === 'gps') {
            return {...dropdownLocal, children: dropdownLocal.children.filter((child) => {
                return metrics.find((metric) => metric.name === child.label)?.visible
              })
            }
          }
          return dropdownLocal
        }))
      } else {
        setDropDownsLocal(dropdowns.filter(dropdown => {
          const gpsMetrics = all_metric_types?.gps
          const gpsMetricNames = gpsMetrics?.map((metric) => metric.name)
          if (gpsMetricNames?.includes(dropdown.label)) {
            // means dropdown label is for a GPS metric = we check visibility
            return gpsMetrics.find((metric) => metric.name === dropdown.label)?.visible
          }
          else {
            // naive search to go through all metrics, and then check whether the metric is
            // get all metrics from keys other than 'gps'
            const nonGpsMetrics = Object.entries(all_metric_types)
                .filter(([key]) => key !== 'gps')
                .flatMap(([_, value]) => value);

            return nonGpsMetrics
          }
        }))
      }
    }
  }, [dropdowns])

  const fetchSingleStatTileData = useCallback(async (id) => {
    try {
      const baseParams = {
        unique_identifier: id,
        comparison_key: option,
        end_date: endDate,
        start_date: startDate,
      };
  
      const conditionalParams = type === "player" && playerId
        ? { player_id: playerId }
        : type === "team"
          ? { ...(position && { position }), ...(player_group && { player_group }) }
          : "-";
      if (startDate && endDate){
        return trainingAPI.getSingleStatTileData({
          ...baseParams,
          ...conditionalParams,
        });
      } else {
        return '-'
      }
    } catch (e) {
      console.log("Error fetching stat tile data:", e);
      return '-'
    }
  }, [option, startDate, endDate, playerId, type, position, player_group]);

  const fetchStatTileData = useCallback(async () => {
    if (!metric_identifier_with_stat || !isAssignedMetric(metric_identifier_with_stat, metrics)) {
      setStatData({});
      return;
    }

    setLoading(true);
    try {
      const statTileData = await fetchSingleStatTileData(metric_identifier_with_stat);
      setStatData(statTileData);
    } catch (e) {
      console.error("Error fetching stat tile data:", e);
      setStatData('-');
    } finally {
      setLoading(false);
    }
  }, [metric_identifier_with_stat, fetchSingleStatTileData]);

  useEffect(() => {
    fetchStatTileData();
  }, [fetchStatTileData, positionFilter]);

  const handleMenuClick = useCallback(({ key }) => {
    onChange(`${key}-avg`);
  }, [onChange]);

  const getStatButtonText = () => {
    if (metric_stat == "avg") { return "A" }
    if (metric_stat == "max") { return "B" }
    if (metric_stat == "sum") { return "C" }
    return "A"
  }

  const getStatButtonColor = () => {
    if (metric_stat == "avg") { return '#1790ff'}
    if (metric_stat == "max") { return '#008000'}
    if (metric_stat == "sum") { return '#800080' }
    return '#1790ff'
  }

  const handleToggleStat = useCallback(() => {
    let pfx = metric_id;
    let next = metric_stat == "avg" ? "max" : metric_stat == "max" ? "sum" : "avg";
    onChange(`${pfx}-${next}`);
  }, [onChange]);

  const title = !metric ? "Choose Metric" : getMetricDropdownLabel(metric);

  return (
      <Card
        bodyStyle={{ padding: "5px 0px 0px 0px", display: 'flex', flexDirection: 'column', height: '100%' }}
        style={{
          width: innerWidth < 1800? '100%' : 320,
          minWidth:270,
          maxWidth:320,
          height: 115,//type=="team" ? 115 : innerWidth < 1800 ? 115 : 120,
          paddingBottom: 0, //type == "team" ? 0 : innerWidth < 1800? 25 : 0,
          borderRadius: 5,
          borderColor: "#cccccc",
          position: "relative",
        }}
        hoverable
        className={`${metric_type}-stat-tile`}
			  itemx={metric?.name}
      >
        <Row>
          <Dropdown
            menu={{
              items: dropdownsLocal || [],
              onClick: handleMenuClick,
            }}
            trigger={["hover"]}
          >
            <Link>
              <Button
                style={{
                  fontSize: 16,
                  height: "auto",
                  whiteSpace: "nowrap",
                  width: innerWidth < 1800? '100%' : 320,
                  maxWidth: 280,
                  minWidth:160,
                  textAlign: "left",
                  overflow: "hidden",
                }}
                size="small"
                type="text"
              >
                <div className={title.length > 33 ? "labelContainer": 'none'}> 
                  <span style={{width: window.innerWidth < 1800? (240/1800)*window.innerWidth : 280}}>{title}</span>
                  </div>

              </Button>
            </Link>
          </Dropdown>
          <Tooltip 
            title={(<span>A: Average <br></br> B: Best <br></br> C: Cumulative</span>)}
            >
          <Button 
            type="primary" 
            size="small" 
            shape="round"
            style={{ 
              position: 'absolute', 
              right: '4px',
              backgroundColor: getStatButtonColor(),
              borderWidth: 0,
              padding: '0px 8px',
              borderRadius: '5px',
            }}
            onClick={handleToggleStat}
            value={metric_stat}
            >
            {getStatButtonText()}
            </Button>
            </Tooltip>
            
        </Row>
        <Row 
          style={{ 
            overflow: 'auto',
            marginTop: '0px', 
            minHeight: 60, 
            height: '100%',
            paddingLeft: '10px',
            '::WebkitScrollbar': {
              display: 'none'
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            width: "87%"
          }} 
          wrap={true}
        >
          {loading ? (
            <Spin />
          ) : (
            statData.length !== 0 && (<>
              <CompactStatisticNumber
                metricStat={statData}
                dynamicFontSizing={true}
                isAsym={statData.is_asym}
                show_delta={metric_stat !== "sum" && option !== "selected_date_range"}
              />
            </>)
          )}
        </Row>
        { (typeof statData.latest_value) !== 'string' && (type == "player") ? (
          <Tooltip title={(<span>T: Team Average <br></br> P: Positional Average</span>)}>
          <div
            style={{
              position: "absolute",
              paddingTop: innerWidth < 1500? "5px": "0px",
              bottom: "5px",
              right: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <StatValue label="T" value={statData?.team?.value} color={statData?.team?.color} isAsym={statData?.is_asym} />
            <StatValue label="P" value={statData?.pos?.value} color={statData?.pos?.color} isAsym={statData?.is_asym} />
          </div>
        </Tooltip>
        ) : null }
      </Card>
    );
};

const StatValue = ({ label, value, color, isAsym=false }) => {

  const fontSize = isAsym ? 11 : 15;
  const lineHeight = isAsym ? 0.9 : 1.2;

  return (
  <div
    style={{
      color: color || 'inherit',
      marginBottom: '2px',
      lineHeight: lineHeight,
      fontSize: fontSize
    }}
  >
    {label}: {value ?? '-'}
  </div>
)};

export default React.memo(CompactStatTile);